import { Dispatch, SetStateAction } from 'react';

import { numberToCurrency } from '@/utils/Formatter';
import { UseFormik } from '@/utils/Formik/types';

import { useGuestDamage } from '@/hooks/GuestDamage/useGuestDamage';

import FormButton from '@/components/FormButton/FormButton';
import { CopyLink } from '@/components/GuestDamage/components/CopyLink';
import TrousseauForm from '@/components/GuestDamage/components/Forms/TrousseauForm';

import {
  ButtonContainer,
  GridContainer,
  LinkText,
  TrousseauFormContainer,
  TrousseauFormItem,
} from './styles';

interface TrousseauFormViewProps {
  formik: UseFormik<any>;
  quantity: number;
  setQuantity: Dispatch<SetStateAction<number>>;
  isEditingForm: boolean;
  setIsEditingForm: Dispatch<SetStateAction<boolean>>;
}

const TrousseauFormView = ({
  formik,
  quantity,
  setQuantity,
  isEditingForm,
  setIsEditingForm,
}: TrousseauFormViewProps) => {
  const { selectedGuestDamage, handleOpenFile } = useGuestDamage();

  return (
    <>
      {isEditingForm ? (
        <TrousseauForm
          formik={formik}
          quantity={quantity}
          setQuantity={setQuantity}
          isEditingForm={isEditingForm}
        />
      ) : (
        <TrousseauFormContainer
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          key="trousseauForm"
          transition={{
            duration: 0.4,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <GridContainer>
            <TrousseauFormItem>
              <h3>Qual item do enxoval foi danificado/extraviado?</h3>
              <p>{selectedGuestDamage.item_name || '-'}</p>
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Quantidade</h3>
              <p>{selectedGuestDamage.item_quantity || '-'}</p>
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>O que precisa ser feito?</h3>
              <p>{selectedGuestDamage.resolution || '-'}</p>
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Evidências</h3>
              {selectedGuestDamage.evidences && selectedGuestDamage?.evidences?.length > 0
                ? selectedGuestDamage.evidences?.map((evidence) => (
                    <LinkText
                      onClick={() =>
                        handleOpenFile(evidence.evidence?.url!, evidence.evidence?.name!)
                      }
                    >
                      {evidence.evidence?.name}
                    </LinkText>
                  ))
                : '-'}
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Valor</h3>
              <p>{numberToCurrency(selectedGuestDamage.item_price)}</p>
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Link do orçamento</h3>
              <CopyLink link={selectedGuestDamage.quotation_link} />
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Orçamento / Nota fiscal</h3>
              <LinkText
                onClick={() =>
                  handleOpenFile(
                    selectedGuestDamage.quotation_file?.url!,
                    selectedGuestDamage.quotation_file?.name!,
                  )
                }
              >
                {selectedGuestDamage.quotation_file?.name || '-'}
              </LinkText>
            </TrousseauFormItem>
            <TrousseauFormItem>
              <h3>Observações</h3>
              <p>{selectedGuestDamage.observation || '-'}</p>
            </TrousseauFormItem>
          </GridContainer>
          <ButtonContainer>
            <FormButton onClick={() => setIsEditingForm(true)}>Editar item</FormButton>
          </ButtonContainer>
        </TrousseauFormContainer>
      )}
    </>
  );
};

export default TrousseauFormView;
